export default __webpack_public_path__ + "static/media/AFlightToNYC_02.9fec7ccf.png";